```vue
<template>
  <div class="table-container">
    <table
      id="ticketmedioprodutos"
      class="w-full border border-gray-200 rounded-lg shadow-sm table-fixed"
    >
      <thead class="bg-gray-100 text-gray-800 font-semibold text-sm sticky top-0 z-10">
        <tr>
          <th class="py-1 px-4 text-left w-[250px]">Produto</th>
          <th class="py-1 px-4 text-right">
            Receita
            <button
              @click="sortBy('receita_total')"
              class="ml-1 text-gray-600 hover:text-gray-800"
            >
              <span
                :class="{
                  'text-blue-600': sortKey === 'receita_total' && sortOrder === 'asc',
                }"
                >↑</span
              >
              <span
                :class="{
                  'text-blue-600': sortKey === 'receita_total' && sortOrder === 'desc',
                }"
                >↓</span
              >
            </button>
          </th>
          <th class="py-1 px-4 text-center">
            Quantidade
            <button
              @click="sortBy('quantidade_total')"
              class="ml-1 text-gray-600 hover:text-gray-800"
            >
              <span
                :class="{
                  'text-blue-600': sortKey === 'quantidade_total' && sortOrder === 'asc',
                }"
                >↑</span
              >
              <span
                :class="{
                  'text-blue-600': sortKey === 'quantidade_total' && sortOrder === 'desc',
                }"
                >↓</span
              >
            </button>
          </th>
          <th class="py-1 px-4 text-right">
            Ticket Médio
            <button
              @click="sortBy('ticket_medio')"
              class="ml-1 text-gray-600 hover:text-gray-800"
            >
              <span
                :class="{
                  'text-blue-600': sortKey === 'ticket_medio' && sortOrder === 'asc',
                }"
                >↑</span
              >
              <span
                :class="{
                  'text-blue-600': sortKey === 'ticket_medio' && sortOrder === 'desc',
                }"
                >↓</span
              >
            </button>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr
          v-for="(item, index) in sortedData"
          :key="item.prod_id_psi"
          :class="{
            'bg-gray-50': index % 2 === 0,
            'bg-white': index % 2 !== 0,
            'hover:bg-gray-100': true,
          }"
          class="transition-colors duration-200"
        >
          <td class="py-2 px-4 text-gray-700 text-sm truncate">{{ item.titulo }}</td>
          <td class="py-2 px-4 text-right text-gray-600 text-sm">
            {{ formatCurrency(item.receita_total) }}
          </td>
          <td class="py-2 px-4 text-center text-gray-600 text-sm">
            {{ item.quantidade_total }}
          </td>
          <td class="py-2 px-4 text-right text-gray-600 text-sm">
            {{ formatCurrency(item.ticket_medio) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  ticketMedioData: {
    type: Array,
    required: true,
  },
});

const sortKey = ref("ticket_medio");
const sortOrder = ref("desc");

// Formatar valores monetários
const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

// Ordenação
const sortedData = computed(() => {
  const sorted = [...props.ticketMedioData];
  if (sortKey.value) {
    sorted.sort((a, b) => {
      const valueA = a[sortKey.value];
      const valueB = b[sortKey.value];
      if (sortOrder.value === "asc") {
        return valueA > valueB ? 1 : -1;
      }
      return valueA < valueB ? 1 : -1;
    });
  }
  return sorted;
});

const sortBy = (key) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  } else {
    sortKey.value = key;
    sortOrder.value = "asc";
  }
};
</script>

<style scoped>
.table-container {
  @apply max-h-[300px] overflow-y-auto overflow-x-auto mt-4;
}

table {
  @apply w-full border-collapse;
}

th,
td {
  @apply border border-gray-200;
}

th:first-child,
td:first-child {
  @apply w-[250px] max-w-[250px] truncate;
}

.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  @apply bg-gray-100;
}

.table-container::-webkit-scrollbar-thumb {
  @apply bg-gray-400 rounded;
}

.table-container::-webkit-scrollbar-thumb:hover {
  @apply bg-gray-500;
}
</style>
```
